import { defineAction } from '~/prix'
import { z } from 'zod'
import ruralPropertyUpdateAction from './ruralPropertyUpdate.action.json' assert { type: 'json' }
import { ruralPropertyUpsertInputObject } from '../ruralPropertyObject'

const ruralPropertyUpdateDefinition = defineAction({
  ...ruralPropertyUpdateAction,

  input: ruralPropertyUpsertInputObject,
  output: z.object({}),
})

export default ruralPropertyUpdateDefinition
